import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/context/I18nContext";
import { Cookie } from "lucide-react";

export const CONSENT_KEY = "cookie_consent";

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export const CookieConsent = () => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-0 z-[1000] border-t border-slate-200 bg-white/95 backdrop-blur-md shadow-[0_-4px_20px_rgba(0,0,0,0.06)] dark:border-slate-700 dark:bg-slate-900/95"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" strokeWidth={1.75} />
          <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            {t("cookies.message")}{" "}
            <Link to="/privacy" className="font-medium text-blue-600 underline underline-offset-2" data-testid="cookie-privacy-link">
              {t("cookies.policyLink")}
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={() => choose("rejected")} data-testid="cookie-reject">
            {t("cookies.reject")}
          </Button>
          <Button size="sm" onClick={() => choose("accepted")} data-testid="cookie-accept">
            {t("cookies.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
};
